import { useEffect } from 'react';

const handleWindowBeforeUnload = () => '';

export const useAvoidBeforeUnload = () => {
  useEffect(() => {
    window.onbeforeunload = handleWindowBeforeUnload;
    return () => {
      window.onbeforeunload = null;
    };
  }, []);
};
